(function () {
  var STORAGE_KEY = 'cf_recently_viewed';
  var MAX_STORE = 8;
  var MAX_DISPLAY = 6;

  function getStored() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function setStored(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  // If currently on a product page, record it (most-recent-first, no duplicates)
  var path = window.location.pathname;
  var onProductPage = path.indexOf('/products/') === 0;
  var currentHandle = onProductPage ? path.split('/products/')[1].split('?')[0].split('/')[0] : null;

  if (currentHandle) {
    var list = getStored().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    if (list.length > MAX_STORE) list = list.slice(0, MAX_STORE);
    setStored(list);
  }

  // Render section (container only exists on non-home pages, injected server-side)
  var wrapper = document.getElementById('rv-products-wrapper');
  if (!wrapper) return;

  var stored = getStored().filter(function (h) { return h !== currentHandle; }).slice(0, MAX_DISPLAY);
  if (stored.length === 0) return;

  Promise.all(
    stored.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })
  ).then(function (products) {
    products = products.filter(Boolean);
    if (products.length === 0) return;

    var html = '<div class="rv-products"><h2>Recently Viewed</h2><div class="rv-grid">';
    products.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var price = (p.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
      html +=
        '<a class="rv-card" href="/products/' + p.handle + '">' +
          '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
          '<p class="rv-card-title">' + p.title + '</p>' +
          '<p class="rv-card-price">\u20B9' + price + '</p>' +
        '</a>';
    });
    html += '</div></div>';
    wrapper.innerHTML = html;
  });
})();